<template>
  <v-card elevation="2" class="pa-4">
    <div class="d-flex">
      <v-spacer></v-spacer>
      <div class="mx-n2">
        <VisibilityToggleButton
          v-model="showRankTable"
          :show-text="$t('ranks.showRankTable')"
          :hide-text="$t('ranks.hideRankTable')"
        />
        <InstructionIcon v-model="showInstruction" />
        <InstructionList
          :show="showInstruction"
          :list="$t('ranks.instructions')"
        />
      </div>
    </div>
    <div v-show="showRankTable">
      <div class="flex-wrap align-center">
        <ModeToggleButtons
          class="mt-4"
          v-model="countMode"
          :modes="countModes"
          :label="$t('ranks.countMode')"
          id="ranks-count-mode"
        />
      </div>
      <v-row>
        <v-col cols="12" lg="6">
          <RankTable :headers="moodsHeaders" :rows="moodsRows" />
        </v-col>
        <v-col cols="12" lg="6">
          <RankTable :headers="motifsHeaders" :rows="motifsRows" />
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import VisibilityToggleButton from "@/components/VisibilityToggleButton.vue";
import InstructionList from "@/components/InstructionList.vue";
import InstructionIcon from "@/components/InstructionIcon.vue";
import ModeToggleButtons from "@/components/ModeToggleButtons";
import RankTable from "./RankTable.vue";
import { countWords } from "@/utils/process-rank-data";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    VisibilityToggleButton,
    InstructionIcon,
    InstructionList,
    ModeToggleButtons,
    RankTable
  },
  data: () => ({
    showRankTable: true,
    showInstruction: false,
    countMode: "countWithoutDuplicates",
    moodRankMap: new Map(),
    motifRankMap: new Map()
  }),
  computed: {
    ...mapState(["filteredPoems"]),
    ...mapGetters(["sankeyThemesSet", "colorScale"]),
    countModes() {
      return ["countWithoutDuplicates", "countWithDuplicates"].map(mode => ({
        text: this.$t(`ranks.${mode}`),
        value: mode
      }));
    },
    moodsHeaders() {
      return this.getHeaders("mood", this.sankeyThemesSet);
    },
    motifsHeaders() {
      return this.getHeaders("motif", this.sankeyThemesSet);
    },
    moodsRows() {
      return this.showRankTable
        ? countWords(
            this.filteredPoems,
            "mood",
            this.sankeyThemesSet,
            "theme",
            this.countMode === "countWithDuplicates"
          )
        : [];
    },
    motifsRows() {
      return this.showRankTable
        ? countWords(
            this.filteredPoems,
            "motif",
            this.sankeyThemesSet,
            "theme",
            this.countMode === "countWithDuplicates"
          )
        : [];
    }
  },
  methods: {
    getHeaders(type, themes) {
      return [
        {
          text: this.$t(`data.${type}`),
          value: "key",
          sortable: true,
          filterable: true
        },
        ...["_all", ...themes].map(theme => ({
          text: theme === "_all" ? this.$t("ranks.allPoems") : theme,
          value: theme,
          sortable: true,
          filterable: false,
          align: "end"
        }))
      ];
    }
  }
};
</script>
